const formatNumber = (value, isForPDF = false) => {
  // remove all non digit characters - preventing user from entering anything other than numbers
  const numericValue = isForPDF
    ? String(value)
    : String(value).replace(/[^\d.]/g, "");

  // split the number into parts before and after the decimal point
  const parts = numericValue.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas for thousands

  // Ensure only up to two decimal places
  if (parts[1]) {
    parts[1] = parts[1].substring(0, 2);
  }

  return parts.join(".");
};

export default formatNumber;
